exports.install = function (Vue, options) {
	Vue.prototype.xxx = function (obj) {
				
	};
	
}